import { toast } from "sonner";
import { CheckCircle, FilePdf } from "@phosphor-icons/react";
import { useFetch } from "@/lib/useFetch";
import { API, api, errMsg, fmtDate } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const TransferDialog = ({ r, onClose, onDone }) => {
  const { data, loading } = useFetch(`/me/registrations/${r.id}/transfer-options`);
  const go = async (eid) => {
    try { await api.post(`/me/registrations/${r.id}/transfer`, { event_id: eid }); toast.success("Ticket moved to the new date"); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="transfer-dialog">
        <DialogHeader><DialogTitle>Move ticket {r.ticket_code} to another date</DialogTitle></DialogHeader>
        {loading ? <p className="text-sm">Loading dates…</p> : !data || data.length === 0 ? <p className="text-sm text-[#475569]" data-testid="transfer-none">No other dates have seats right now. We'll email you when a new date opens, or contact support.</p> : (
          <div className="max-h-80 space-y-2 overflow-y-auto">
            {data.map((e) => (
              <button key={e.id} onClick={() => go(e.id)} className="flex w-full items-center justify-between rounded-md border p-3 text-left text-sm transition-colors hover:border-[#E0A21B]" data-testid={`transfer-option-${e.id}`}>
                <span><span className="font-semibold">{e.city}</span> · {fmtDate(e.start_at, e.timezone)}</span><span className="text-xs text-[#475569]">{e.seats_left} seats left</span>
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export const AttendanceActions = ({ r, reload, onTransfer }) => {
  const upcoming = r.event && r.event.start_at > new Date().toISOString();
  const answer = async (coming) => {
    if (!coming && !window.confirm("Release your seat? It goes to the waitlist and you can move your ticket to another date.")) return;
    try {
      await api.post(`/me/registrations/${r.id}/attendance`, { coming });
      toast.success(coming ? "Thanks, see you there" : "Seat released");
      if (!coming) onTransfer(r);
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      {upcoming && r.status === "confirmed" && (r.attendance === "yes"
        ? <span className="flex items-center gap-1 text-xs font-semibold text-[#1E8E5A]" data-testid={`attendance-yes-${r.id}`}><CheckCircle weight="fill" /> Coming</span>
        : <span className="flex items-center gap-1 text-xs" data-testid={`attendance-ask-${r.id}`}>Coming?
            <button className="btn-outline px-2 py-1 text-xs" onClick={() => answer(true)} data-testid={`attend-yes-btn-${r.id}`}>Yes</button>
            <button className="btn-outline px-2 py-1 text-xs" onClick={() => answer(false)} data-testid={`attend-no-btn-${r.id}`}>I can't make it</button>
          </span>)}
      {r.status === "released" && <button className="btn-gold px-3 py-1.5 text-sm" onClick={() => onTransfer(r)} data-testid={`transfer-btn-${r.id}`}>Move to another date</button>}
    </>
  );
};

export const SignedDocs = ({ orderId, admin = false }) => {
  const base = admin ? `/admin/orders/${orderId}` : `/me/orders/${orderId}`;
  const { data } = useFetch(`${base}/signatures`);
  if (!data || data.length === 0) return null;
  return (
    <div className="panel no-print mb-4 p-4 text-sm" data-testid="signed-docs">
      <div className="eyebrow mb-2">Signed risk warning, terms and refund policy</div>
      {data.map((s) => (
        <a key={s.id} href={`${API}${base}/signed/${s.attendee_index}.pdf`} target="_blank" rel="noreferrer" className="flex items-center gap-2 py-1 underline" data-testid={`signed-pdf-${s.attendee_index}`}>
          <FilePdf size={18} className="text-[#C8382E]" /> {s.attendee_name}: signed {fmtDate(s.signed_at)}
        </a>
      ))}
    </div>
  );
};
